import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { RoleService } from '../../services/role.service';
import { User } from '../../models/user';
import { BaseService } from '../../base.service';
import 'rxjs/Rx' ;


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})


export class UserComponent implements OnInit {

  title_component: string;
  public listRole = [];
  users: User[];
  user_id: number;
  sub: any;
  size: number;
  email: string;
  role: string;
  value: string;

  loading = false;
  page = 1;
  next_status: boolean;

  total = 10000000;
  maxSize: number = 5;
  bigCurrentPage: number = 1;
  status: boolean;

  @ViewChild("btnGenerateReport") btnGenerateReport: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private roleService: RoleService,
    private baseService: BaseService,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): any {
    this.title_component = 'Usuarios';
    this.baseService.changedComponentName(this.title_component);

    this.getRoles();
    this.page = 0;
    this.size = 10;
    this.email = '';
    this.role = '';
    this.status = true;

    if (this.baseService.request && this.baseService.component === 'user') {
      this.size = this.size;
      this.page = this.baseService.request.page+1;
      this.email = this.baseService.request.email;
      this.role = this.baseService.request.role;
      this.getMessages(this.baseService.request.size, this.baseService.request.page+1, this.baseService.request.email, this.baseService.request.role);
      this.bigCurrentPage = this.page;
    } else {
      this.getMessages(this.size, this.page, this.email, this.role);
    }
  }


  getUserDetail(event, user: User): any {
    this.user_id = user.id;
    const link = ['/dashboard/user', this.user_id];
    this.router.navigate(link);
  }

  getRoles(): any {
    this.roleService.getAll()
      .subscribe(data => {
        this.listRole.push({ value: '', desc: 'Filtar por Rol' });
        data.forEach((rol) => {
          this.listRole.push({ value: rol.id, desc: rol.name });
        });
      });
  }

  onClicked(value: string) {
      this.email = value['email'];
      this.role = value['role'];
      this.bigCurrentPage = 1;
      this.getMessages(this.size, this.page, this.email, this.role);
  }

  getMessages(size, page, email, role): void {
    this.baseService.component = 'user';
    this.baseService.request = {
      'size': size,
      'page': page - 1,
      'email': email,
      'role': role
    };
    this.userService.getAll(size, page-1, email, role)
      .subscribe(data => {
        if (data) {
          this.users = data['content'];
          this.total = data['totalElements'];
        }
      });
  }
  pageChanged(event: any): void {
    this.getMessages(this.size, event.page, this.email, this.role);
  }
  generateReport(email, role, status, page, size) {
    this.userService.report(email, role, status, page, size)
      .subscribe(data => {
        this.downloadFile(data)
      }, error => {
        console.error(error);
      });
  }
  downloadFile(data: Blob): void{
    const blob = data;
    const url = window.URL.createObjectURL(blob);
    const link = this.renderer.selectRootElement(this.btnGenerateReport.nativeElement);
    link.href = url;
    link.download = 'user.csv';
    link.click();
    window.URL.revokeObjectURL(url);
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/user/user.component.ts